import React from 'react';
import '../../styles/MetaSistema.css';
import metasistemaData from '../../data/whatMetaSistema.json';

const WhatMetaSistema = () => {
  return (
    <section className="what-metasystem-section">
      <div className='container'>
        {/* Título */}
        <div className="title-container" data-aos="fade-up">
          <h2 className="title">¿Qué es el MetaSistema?</h2>
          <div className="title-underline"></div>
        </div>

        <div className="section-description" data-aos="fade-up">
          <p>
            Nuestro <span className="description-highlight">MetaSistema</span> combina lo mejor de nuestros activos digitales
            (sitios, micrositios, plataformas y RRSS), contenidos de calidad y publicidad segmentada para ofrecer
            soluciones integrales.
          </p>
          <p>
            A través de un <span className="description-highlight">ecosistema integral</span>, conectamos con audiencias
            específicas mediante activos sólidos, contenidos a medida y diversas opciones de amplificación publicitaria.
          </p>
          <p>
            <span className="description-highlight">Generamos impacto</span>, fortalecemos la presencia digital y <span className="description-highlight">garantizamos resultados medibles.</span>
          </p>
        </div>


        {/* Contenido principal */}
        <div className="row justify-content-center">
          {metasistemaData.map((item, index) => (
            <div className="col-lg-4 col-md-6 d-flex p-3" key={index} data-aos="fade-up" data-aos-delay={`${index * 200}`}>
              <div className={`metasystem-card text-center shadow-sm border-0 p-4 flex-fill rounded-card ${item.bgColor}`}>
                <div className="icon-container mb-3">
                  <img src={item.icon} alt={item.title} className="icon-image img-filter" data-aos="zoom-out" />
                </div>
                <h3 className="fw-bold text-success">{item.title}</h3>
                <p className='fw-bold'>{item.description}</p>
                <ul className="text-start list-unstyled">
                  {item.points.map((point, i) => (
                    <li key={i} className="mb-2"> {point}</li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>

        <div className="metasystem-footer p-3 pb-5" data-aos="fade-up" data-aos-offset="50">
          Generamos impacto, fortalecemos la presencia digital y <span> garantizamos resultados medibles.</span>
        </div>
      </div>
    </section>
  );
};

export default WhatMetaSistema;


